import { render, staticRenderFns } from "./personal-summary.vue?vue&type=template&id=202cda23&scoped=true"
import script from "./personal-summary.vue?vue&type=script&lang=js"
export * from "./personal-summary.vue?vue&type=script&lang=js"
import style0 from "./personal-summary.vue?vue&type=style&index=0&id=202cda23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202cda23",
  null
  
)

export default component.exports